import React from "react";
import "./style.css";
import { Link } from "react-router-dom";
import chevronRight from "../../../../../Assets/Images/chevron-right.svg";
import moment from "moment";

const TopBanner = ({ data }) => {
  return (
    <div className="quiz-detail-banner">
      <Link to="/learning-programs" className="top-hdng mt-3  px-4 text-decoration-none">
        <img className="me-3 mb-1" src={chevronRight} alt="chevronRight" style={{ height: "1.1rem", width: "1.1rem" }} />
        {data?.event_name}
      </Link>
      <div className="top-image mt-3">
        <div className="quiz-banner-content">
          <div class="content-sec">
            <p class="hdng">Welcome to {data?.event_name}</p>
            <p class="desc-para">
              Largest national level online inter school competition to
              <br />
              achieve National Education Policy 2020 goals
            </p>
            <p class="timeline">{moment(data?.start_date).format("DD MMM YYYY")} - {moment(data?.end_date).format("DD MMM YYYY")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBanner;
